import { createReducer } from "actionware";
import { createState } from "stateware";
import { fetchLenderPortfolioV2, resetToInitialState } from "./summaryActions";
import { toggleErrorCard } from "../fundingLimit/fundingLimitActions";

const initialState = createState({
  portfolio: {},
  portfolioSummary: {},
  errorCard: {
    errorCardVisible: false,
    errorApi: "",
    errorMessage: "",
  },
});

export default createReducer(initialState)
  .on(fetchLenderPortfolioV2, (state, portfolio) => {
    return initialState.copy({ ...state, portfolioSummary: { ...portfolio } });
  })
  .onError(fetchLenderPortfolioV2, (state, error) => {
    return initialState.copy({
      ...state,
      errorCard: {
        errorCardVisible: true,
        errorApi: "fetchLenderPortfolioV2",
        errorMessage: error,
      },
    });
  })

  .on(resetToInitialState, (state, data) => {
    return initialState.copy({
      ...state,
      portfolio: {},
      portfolioSummary: {},
      errorCard: {
        errorCardVisible: false,
        errorApi: "",
        errorMessage: "",
      },
    });
  })

  .on(toggleErrorCard, (state, errorCardData) => {
    return initialState.copy({
      ...state,
      errorCard: {
        errorApi: errorCardData.api,
        errorCardVisible: errorCardData.flag,
      },
    });
  });
